export default {
  myCourse_compulsory:'必修',
  myCourse_elective:'選修',
  myCourse_web_check_course:'0402Web-查看课程',
  myCourse_web_show_course:'0401Web-显示我的课程列表',
}
